export default {
  'menu.home': '首页',
  'menu.route.Index': '首页',
  'menu.route.Center': '个人中心',
  'menu.route.Settings': '个人设置',
  'menu.route.ZrInfo': '短信设置',
  'menu.route.JobLog': '调度日志',
  'menu.route.AuthUser': '分配用户',
  'menu.route.NoticeForm': '公告编辑',
  'menu.route.GenEdit': '修改生成配置',
  'menu.route.System': '系统管理',
  'menu.route.Monitor': '系统监控',
  'menu.route.Tool': '系统工具',
  'menu.route.User': '用户管理',
  'menu.route.Role': '角色管理',
  'menu.route.Menu': '菜单管理',
  'menu.route.Dept': '部门管理',
  'menu.route.Post': '岗位管理',
  'menu.route.Config': '参数设置',
  'menu.route.Notice': '通知公告',
  'menu.route.Log': '日志管理',
  'menu.route.Server': '服务监控',
  'menu.route.Cache': '缓存监控',
  'menu.route.CacheList': '缓存列表',
  'menu.route.Gen': '代码生成',
  'menu.route.Swagger': '系统接口',
  'menu.route.Operlog': '操作日志',
  'menu.route.Logininfor': '登录日志',
  'menu.route.Pay': '支付管理',
  'menu.route.Pay/channel': '支付渠道',
  'menu.route.Pay/order': '支付订单',
  'menu.route.Pay/orderrefund': '退款订单',
  'menu.route.Dbdoc': '数据库文档',
  'menu.route.App/user': '用户管理',
  'menu.route.Biz': '用户信息',
  'menu.route.Cancel': '用户注销',
  'menu.route.Banner': '广告管理',
  'menu.route.Yunying': '运营管理',
  'menu.route.Baozhuangguanli': '包装管理',
  'menu.route.Category': '分类管理',
  'menu.route.Goods': '产品管理',
  'menu.route.Spec': '规格管理',
  'menu.route.Machine': '调机米数',
  'menu.route.PrintMultiples': '印刷倍数',
  'menu.route.CuttingTool': '刀具费用',
  'menu.route.Order': '订单管理',
  'menu.route.GoodsOrder': '订单管理',
  'menu.route.HomeNotice': '首页通知',
  'menu.route.Feedback': '意见反馈',
  'menu.route.Transportation': '运输方式',
  'menu.route.SpecialMultiple': '特殊倍数',
  'menu.route.ToolMagazine': '刀库管理',
  'menu.route.OrderSettlement': '结算订单',
  'menu.names.首页': '首页',
  'menu.names.个人中心': '个人中心',
  'menu.names.个人设置': '个人设置',
  'menu.names.短信设置': '短信设置',
  'menu.names.调度日志': '调度日志',
  'menu.names.分配用户': '分配用户',
  'menu.names.公告编辑': '公告编辑',
  'menu.names.修改生成配置': '修改生成配置',
  'menu.names.系统管理': '系统管理',
  'menu.names.系统监控': '系统监控',
  'menu.names.系统工具': '系统工具',
  'menu.names.用户管理': '用户管理',
  'menu.names.角色管理': '角色管理',
  'menu.names.菜单管理': '菜单管理',
  'menu.names.部门管理': '部门管理',
  'menu.names.岗位管理': '岗位管理',
  'menu.names.参数设置': '参数设置',
  'menu.names.通知公告': '通知公告',
  'menu.names.日志管理': '日志管理',
  'menu.names.服务监控': '服务监控',
  'menu.names.缓存监控': '缓存监控',
  'menu.names.缓存列表': '缓存列表',
  'menu.names.代码生成': '代码生成',
  'menu.names.系统接口': '系统接口',
  'menu.names.操作日志': '操作日志',
  'menu.names.登录日志': '登录日志',
  'menu.names.支付管理': '支付管理',
  'menu.names.支付渠道': '支付渠道',
  'menu.names.支付订单': '支付订单',
  'menu.names.退款订单': '退款订单',
  'menu.names.数据库文档': '数据库文档',
  'menu.names.用户信息': '用户信息',
  'menu.names.用户注销': '用户注销',
  'menu.names.广告管理': '广告管理',
  'menu.names.运营管理': '运营管理',
  'menu.names.包装管理': '包装管理',
  'menu.names.分类管理': '分类管理',
  'menu.names.产品管理': '产品管理',
  'menu.names.规格管理': '规格管理',
  'menu.names.调机米数': '调机米数',
  'menu.names.印刷倍数': '印刷倍数',
  'menu.names.刀具费用': '刀具费用',
  'menu.names.订单管理': '订单管理',
  'menu.names.首页通知': '首页通知',
  'menu.names.意见反馈': '意见反馈',
  'menu.names.运输方式': '运输方式',
  'menu.names.特殊倍数': '特殊倍数',
  'menu.names.刀库管理': '刀库管理',
  'menu.names.结算订单': '结算订单'
}
